module.exports = __webpack_public_path__ + "static/media/icon.b3f49a6a.png";